<template>
  <v-dialog
    v-model="dialog"
    width="1000"
  >
    <template v-slot:activator="{ on, attrs }">
      <v-btn 
        icon
        v-bind="attrs"
        v-on="on"
      >
        <v-icon
          color="blue"
        >
          mdi-information
        </v-icon>
      </v-btn>  
    </template>

    <v-card  v-if="jobType == 'device_config'" width="1000">
      <ConfigStatusTable
        :key="item.id"
        :config="returnConfig(item)"
        :items="returnDevices(item)"
      />
    </v-card>
    <v-card v-if="jobType == 'firmwareupdate'" width="1000" height="800">
      <FirmwareStatusTable
        :key="item.id"
        :job="item"
        :items="returnDevices(item)"
        @close="dialog = false"
      />
    </v-card>

    
  </v-dialog>
</template>

<script>

import ConfigStatusTable from './ConfigStatusTable';
import FirmwareStatusTable from './FirmwareStatusTable';

export default {
  name: 'StatusTableWrapper',
  components: {
    ConfigStatusTable,
    FirmwareStatusTable
  },
  props: {
    item: {
      type: Object,
      required: true
    },
    jobType: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      dialog: false
    }
  },
  methods: {
    returnConfig(item) {
      let task = item.Tasks[0];

      if (task.context) {
          return task.context.device_config.data;
      }
    },
    returnDevices(list) {
      let devices = list.Tasks[0].context.devices;

      return devices;
    },
  }
  }
</script>